import React from "react";

export default ({ color, size }) => (
  <svg width={size || 24} height={size || 24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>rectangle-outline</title>
    <path fill={color} d="M4,6V19H20V6H4M18,17H6V8H18V17Z" />
  </svg>
);
